export const AVATAR_STACK_DEFAULT_MAX = 3;
